import Query from '../Report';

export const query = new Query('global-min-max-date');
export const gsc_report_query = new Query('search-summary-min-max-date');
